import {getPolishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Értékelje a cikket',
    message: 'leadott szavazat',
    votes: votes => `${getPolishPlurals(["vélemény", "vélemények", "vélemények"], +votes)},`,
    score: 'értékelés',
  },
  feedback: {
    label: 'Hasznos ez a cikk?'
  }
};
